export type ConcernStatus = "OPEN" | "IN_REVIEW" | "RESOLVED";
export const concernStatuses: Record<ConcernStatus, string> = { OPEN: "Open", IN_REVIEW: "In review", RESOLVED: "Resolved" };
export type ConcernReport = {
  report_id: string;
  reporter_user_id: string | null;
  reporter_name: string;
  organization_id: string | null;
  reported_user_name: string | null;
  project_reference: string | null;
  task_reference: string | null;
  description: string;
  status: ConcernStatus;
  review_notes: string | null;
  created_at: string;
  updated_at: string;
  version: number;
  screenshot: { file_name: string; download_url: string } | null;
};
export type ConcernPage = { reports: ConcernReport[]; has_more: boolean };
